import axios from "../axiosInstance"

export const getStrandedValueDeals = async () => {
  try {
    const res = await axios.get(`/stranded-value`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch stranded value deals")
    }
    return data.deals
  } catch (error) {
    console.error("Error fetching stranded value deals:", error)
    throw error
  }
}
